import React, {useEffect, useState}                 from 'react';
import {useUser}                                    from "../../context/UserProvider/UserProvider";
import SubscribePromo                               from "./subscribePromo";
import {useNavigate}                                from "react-router-dom";
import {Button, Text}                               from "@aws-amplify/ui-react";
import {useQuery}                                   from "react-query";
import StripeService                                from "../../services/stripe.service";
import {useStripeCustomer}                          from "../../requestHooks/useStripeCustomer";
import {LoadingGif, LoadingSimple, LoadingSimplest} from "../UIElements";
import DataSettingsForm                             from "./dataSettings";
import PrivacySettingsForm                          from "./privacySettings";


const UI_STRINGS = require('../../common/ui-strings.json')
const AccountSettingsForm = () => {
    const {authenticatedUser, userAttributes, loadingUser} = useUser();
    const [customer, setCustomer] = useState<any | null>(null);
    const {isFetchingCustomerSubscriptions, fetchCustomerSubscriptions} = useStripeCustomer(
        customer, handleFetchCustomerSubscriptions)

    const [statusMessage, setStatusMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const {signOut} = useUser();
    const navigate = useNavigate();
    const handleUpdate = async (updateFunction: Function, value: string, fieldName: string) => {
        try {
            setLoading(true);
            await updateFunction(value);
            setStatusMessage(`${fieldName} updated successfully!`);
        }
        catch (error) {
            console.error(`Failed to update ${fieldName}:`, error);
            setStatusMessage(`Error updating ${fieldName}!`);
        }
        finally {
            setLoading(false);
        }
    };

    function handleFetchCustomerSubscriptions(res: any) {

        if (res && Array.isArray(res.data)) {
            // Function to determine if there is an active subscription and retrieve its product_id
            const getActiveSubscriptionProductId = (subscriptions: any[]): string | null => {
                const activeSubscription = subscriptions.find(subscription => subscription.status === "active");
                return activeSubscription?.plan?.id || null; // Access product_id from the plan property
            };

            const product_id = getActiveSubscriptionProductId(res.data); // Access the `data` field here
            if (product_id) {
                console.log("Paid subscription confirmed, nothing to do.")
            }
            else {
                console.warn("No active subscription found. Customer is not subscribed to any plan!");
            }
        }
        else {
            console.error("Invalid response format or no subscriptions data found.");
        }
    }

    const subscribeClicked = () => {
        console.log('subscribeClicked');
        // todo: add GA4 and other notifications!
        navigate('/account/checkout', {replace: false});
    }

    const billingButtonClicked = () => {
        console.log('billingButtonClicked');
        requestCustomerPortalSession();
    }


    const {
              isFetching: isLoadingCustomerPortal,
              refetch   : requestCustomerPortalSession,
          } = useQuery<any[], Error>(
        "query-request-customer-portal-session",
        async () => {
            const customerId = userAttributes?.["custom:customer_id"];
            if (!customerId) return null;
            return await StripeService.requestCustomerPortalSession(customerId);
        },
        {
            enabled  : false,
            retry    : 3,
            onSuccess: (res) => {
                handleCustomerPortalSessionStarted(res);
            },
            onError  : (err: any) => {
                console.error(`[ERROR] Error in requestCheckoutSession:`, err);
            },
        }
    );

    function handleCustomerPortalSessionStarted(res: any) {
        if (res) {
            let isCustomerPortalSessionStartedSuccessfully = res.length > 0;
            if (isCustomerPortalSessionStartedSuccessfully) {
                const url = res;
                if (url) {
                    window.open(url, "_blank");
                }
            }
        }

    }


    useEffect(() => {
        if (loadingUser) return
        const customerId = userAttributes?.["custom:customer_id"];
        if (userAttributes && userAttributes.email && userAttributes?.["custom:accountType"] === 'paid')
        {
            // check user's subscriptions:
            if (!customerId) {
                console.log('[DEBUG] Refetching requestCheckoutSession manually');
                fetchCustomerSubscriptions();
            }
            else {
                let customer = {customer_id: customerId,};
                setCustomer(customer);
            }

        }
    }, [loadingUser]);

    useEffect(() => {
        if (loadingUser) return
        // Perform any update logic needed when userAttributes changes.
        // Add any specific logic or API calls that need to be executed
        // when userAttributes are updated.
    }, [userAttributes]);


    function getExpiryDate() {
        const timestampString = userAttributes?.["custom:planExpiryDate"];
        const timestampInt = parseInt(timestampString, 10);
        const date = new Date(timestampInt * 1000);

// Format the date as "18 May 2025"
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            day  : '2-digit', // 2-digit day (e.g., "18")
            month: 'long',  // Full month name (e.g., "May")
            year : 'numeric' // Full year (e.g., "2025")
        }).format(date);

        return formattedDate;
    }

    function getCustomerPortalLabel() {
        if (userAttributes?.["custom:planExpiryDate"] && userAttributes?.["custom:planExpiryDate"] !== "NotSet") {
            return "Renew";
        }
        else {
            return "Manage billing"
        }
    }


    return (
        <div className="account-settings-form">
            <h1 className="mt-5 pt-5 mb-3 mt-sm-3">Manage account</h1>
            {statusMessage && (
                loadingUser || !userAttributes
            ) && (
                 <div>{statusMessage}</div>
             )}
            {!loadingUser && authenticatedUser && userAttributes && (
                <div className="">
                    <div className="account-settings-form__header mb-3">
                        <div>
                            <span className="label-width"
                            >Email: </span>
                            <span
                                className="">{userAttributes.email}</span></div>
                        {userAttributes?.["custom:accountType"] && (
                            <div className="pt-1">
                                <span className="label-width">Subscription plan: </span>
                                <span
                                    className="text-capitalize text-body-emphasis fw-medium pe-4">{userAttributes?.["custom:accountType"]}</span>
                                {userAttributes?.["custom:customer_id"] !== "NotSet" && (
                                    <span>
                                        {userAttributes?.["custom:planExpiryDate"]
                                         && userAttributes?.["custom:planExpiryDate"] !== "NotSet" && (
                                             <span
                                                 className="fs-6 fst-italic text-danger ps-3 align-baseline">Expires on {getExpiryDate()}</span>
                                         )}
                                        <Button
                                            onClick={billingButtonClicked} size="small"
                                            style={{
                                                padding: "2px 10px", marginLeft: "1rem"
                                            }}>{getCustomerPortalLabel()}<span className="ps-2"><i
                                            className="bi bi-box-arrow-up-right"></i></span></Button>
                                        {isLoadingCustomerPortal && (
                                            <span><LoadingSimple/></span>
                                        )}</span>
                                )}
                            </div>

                        )}
                        <div className="mt-5 mt-sm-3 account-settings-form__account-type">
                            {userAttributes?.["custom:accountType"] == 'free' && (
                                <SubscribePromo onUpgradeClick={subscribeClicked}/>
                            )}

                        </div>

                        <div className="container mt-5 mt-sm-3 account-settings-form__app_settings">
                            <DataSettingsForm disabled={userAttributes?.["custom:accountType"] === 'free'}/>
                        </div>
                        <div className="container mt-5 mt-sm-3 account-settings-form__app_settings">

                            <div className="signOutButton">
                                <Button
                                    onClick={() => signOut()} variation="primary" colorTheme="overlay"
                                    style={{marginTop: "2rem"}}>Sign out</Button>
                            </div>
                        </div>
                    </div>

                </div>


            )}
        </div>
    );
};

export default AccountSettingsForm;
